import { AGENCY_PHONE, REUNION_PHONE } from '@/lib/constants/agency'
import { isReunionTimezone } from '@/lib/timezone'

export function useAgencyPhone() {
  return isReunionTimezone() ? REUNION_PHONE : AGENCY_PHONE
}
